import React, { useContext, useEffect, useState, useRef } from 'react';
import { StateApp } from "../context/Context";
import Login from "../Login/Login";
import Cookies from 'js-cookie';
import "../Login/Login.css";
import axios from "axios";
import Loading from "../Loading/Loading";
import { message, notification } from "antd";
import SuccessLogin from "../Modal/Success Login";
import { url } from '../url';
import { requestForToken } from '../firebase';
import { useDispatch } from "react-redux";
import { setUser } from "../slices/UserInformation";
import { toEnglishDigits } from "../utils/numbers";



const Verification = ({ phoneNumber }) => {

    // timer
    const [showTimer, setShowTimer] = useState(true)
    const [minutes, setMinutes] = useState(3);
    const [seconds, setSeconds] = useState(0);

    const {
        handleVerification,
        setHandleVerification,
        loading,
        setLoading,
        setOpenlogin,
        setshowSuccsessLogin,
        completedProfile,
        setcompletedProfile
    } = useContext(StateApp);
    const [showPhone, setShowphone] = useState("");
    const [otp, setOtp] = useState(Array(6).fill(''));
    const inputRefs = useRef([]);
    const dispatch = useDispatch();




    const EditPhone = () => {
        setHandleVerification(!handleVerification);
    };

    useEffect(() => {
        const phoneNumber = Cookies.get("phoneNumber");
        setShowphone(phoneNumber);
    }, []);

    const handleOtpChange = (index, value) => {
        const normalizedValue = toEnglishDigits(value);
        const newOtp = [...otp];
        newOtp[index] = normalizedValue;
        setOtp(newOtp);
        if (normalizedValue.length === 1 && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && otp[index] === '') {
            if (index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };


    function resendCode () {

        axios.post(`${url}/passenger/v1/send-otp`, {
            mobile: phoneNumber
        }).then((response) => {
            if (response.status === 200) {
                setHandleVerification(true);
                setShowTimer(true)
                setLoading(false);
                message.success(response.data.message);
                setSeconds(0)
        setMinutes(3)
            }
        }).catch((error) => {
            if (error) {
                notification.error({
                    message: error?.response?.data?.message
                })
                setLoading(false);
                setShowTimer(false)
            }
        });
    }

    const submit = () => {
        setLoading(true);
        const enteredOtp = otp.slice().join('');

        axios.post(`${url}/passenger/v1/submit-otp`, {
            code: enteredOtp,
            mobile: showPhone
        })
            .then((response) => {
                if (response.status === 200) {
                    setHandleVerification(false);
                    setOpenlogin(false);
                    setLoading(false);
                    setshowSuccsessLogin(true);
                    const authData = response?.data?.data || {};
                    const nextToken = authData?.tokens?.accessToken;
                    const backendUser = authData?.user || {};

                    if (!nextToken) {
                        throw new Error("توکن ورود از سرور دریافت نشد");
                    }

                    localStorage.setItem("accessToken", nextToken);
                    dispatch(setUser({
                        name: backendUser.full_name || "",
                        idCode: backendUser.national_code || "",
                        birthDate: backendUser.birth_date || "",
                        gender: backendUser.gender || "",
                        address: backendUser.address || "",
                        status: backendUser.status || "",
                        mobile: backendUser.mobile || showPhone,
                        accessToken: nextToken,
                        loginInfo: true,
                        loadingProfile: false,
                    }));

                    setcompletedProfile(backendUser.status !== "profile_not_completed");
                    requestForToken(nextToken)
                }
            })
            .catch((error) => {
                if (error) {
                    message.error(error.response?.data.message);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        if (handleVerification) {
            const interval = setTimeout(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                }

                if (seconds === 0) {
                    if (minutes === 0) {
                        clearTimeout(interval);
                        setShowTimer(false)
                    } else {
                        setSeconds(59);
                        setMinutes(minutes - 1);
                    }
                }
            }, 1000);

            return () => {
                clearTimeout(interval);
            };
        } else {
            setSeconds(0)
            setMinutes(3)
        }
    }, [seconds,showTimer,minutes]);


    return (
        <div className="mk-auth-panel">
            {!handleVerification ? (
                <Login />
            ) : (
                <div style={{ fontFamily: 'IRANSansFaNum'}} className="w-full p-5" >
                    <div className="flex flex-col justify-center items-center w-[100%]">
                        <p className="text-[22px] font-[500]">کد تأیید را وارد کنید</p>
                        <p  className="gap-1 flex text-[#8A8D97] text-[16px] mt-4">
                            کد تایید به شماره
                            <p style={{ fontFamily: 'IRANSansFaNum'}} className="text-black text-[16px] font-[600]">{showPhone}</p>
                            ارسال شد
                        </p>
                        <div style={{ direction: "ltr" }} className="flex gap-4 mt-6 ">
                            {otp.map((digit, index) => (
                                <input

                                    ref={el => inputRefs.current[index] = el}
                                    key={index}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    className={`text-[26px] md:w-[40px] md:h-[50px] w-[50px] h-[68px] text-center border border-gray-300 rounded-md focus:outline-none focus:border-[#100E34] ${digit ? 'input-filled' : ''}`}
                                    style={{ direction: 'ltr', "fontFamily": 'IRANSansFaNum'}}
                                    pattern="[0-9]"
                                    autoFocus={index === 0}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="flex justify-center items-center gap-1 mt-6">
                        <p className="text-[16px]">شماره موبایل اشتباه است ؟</p>
                        <p onClick={EditPhone} className="text-[16px] text-[#4F48EC] cursor-pointer">ویرایش</p>
                    </div>
                    <div className="flex flex-col justify-center items-center w-[100%]">

                        <div className={`flex items-center gap-x-2`}>
                            <button className={`text-[16px] text-darkBlue cursor-pointer ${showTimer && `hover:cursor-not-allowed`}`} disabled={showTimer === true} onClick={resendCode}>ارسال مجدد کد</button>
                            <div className={`${showTimer ? "block" : "hidden"}`}>
                                {(minutes === 0) && (seconds === 0) ? null :
                                    <span style={{ fontFamily: 'IRANSansFaNum'}}> {("0" + minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds)} </span>
                                }
                            </div>
                        </div>
                        <button onClick={submit} className="mt-10 bg-[#4F48EC] md:w-[90%] md:h-[40px] md:rounded-[10px] w-[80%] h-[48px] rounded-[10px]">
                            {loading ? (
                                <Loading />
                            ) : (
                                <p className="text-white text-[22px] md:text-[16px]">تایید</p>
                            )}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Verification;
